import { createSelector } from 'reselect';

import {
  selectEntitiesAchievements,
  selectEntitiesAchievementsEntityEligibilityClearMode,
  selectEntitiesAchievementsEntityEligibilityNbBetsToPlace,
  selectEntitiesAchievementsEntityEligibilityNbBetsToWin,
  selectEntitiesAchievementsEntityReward,
} from '../../../selectors/entities/achievements/entitiesAchievementsPrimary.selector';
import { type Selector } from '../../../types/selectors';
import { createResultEqualSelector } from '../../../utils/reselect';
import { type AchievementState } from '../types/state/achievements';
import { AchievementClearModes, AchievementRewardTypes } from '../types/state/achievements';

// #region Complexes
export const selectAchievementIds: Selector<Array<number>> = createResultEqualSelector(
  [selectEntitiesAchievements],
  (achievements) => Object.keys(achievements).map((key) => parseInt(key, 10)),
);

export const selectAchievementFreebetsReward: Selector<
  | {
      amount: number;
    }
  | undefined
> = createSelector([selectEntitiesAchievementsEntityReward], (reward) =>
  reward?.rewardType === AchievementRewardTypes.FREEBETS && reward?.rewardParams ? reward.rewardParams : undefined,
);

export const selectAchievements: Selector<Array<AchievementState>> = createResultEqualSelector(
  [selectAchievementIds, selectEntitiesAchievements],
  (achievementIds, achievementsState) =>
    achievementIds.map((achievementId) => achievementsState[achievementId]).filter((k) => k),
);

export const selectAchievementNbBetsToTry: Selector<number | undefined | null> = createResultEqualSelector(
  [
    selectEntitiesAchievementsEntityEligibilityNbBetsToWin,
    selectEntitiesAchievementsEntityEligibilityNbBetsToPlace,
    selectEntitiesAchievementsEntityEligibilityClearMode,
  ],
  (nbBetsToWin, nbBetsToPlace, clearMode) => {
    if (clearMode === AchievementClearModes.PLACED) {
      return nbBetsToPlace;
    }
    if (clearMode === AchievementClearModes.SETTLED) {
      return nbBetsToWin;
    }
  },
);
// #endregion
